
import { ADMIN_SCOPE } from '../util';
import { useUserScopes } from './useUserScopes';

export interface AdminScope {
	isAdmin: boolean;
	isLoading: boolean;
}

export function useAdminScope(): AdminScope {
	const { scopes, isLoading } = useUserScopes();
	return { isAdmin: scopes.includes(ADMIN_SCOPE), isLoading };
}

export function useIsAdmin(): boolean {
	return useAdminScope().isAdmin;
}
